export class EntityFormTrackers {
  static readonly TRACKER_ENTITY_FORM_FORM_TEST_AND_SAVE_CLICK =
    '[Entity Form] form test & save click';

  static readonly TRACKER_ENTITY_FORM_FORM_SAVE = '[Entity Form] form save';

  static readonly TRACKER_ENTITY_FORM_FORM_SAVE_SUCCESS = '[Entity Form] form save success';

  static readonly TRACKER_ENTITY_FORM_FORM_SAVE_FAILURE = '[Entity Form] form save failure';

  static readonly TRACKER_ENTITY_FORM_FORM_VALIDATION_FAILURE =
    '[Entity Form] form validation failure';

  static readonly TRACKER_ENTITY_FORM_TEST_CONNECTION_SUCCESS =
    '[Entity Form] form test connection success';

  static readonly TRACKER_ENTITY_FORM_TEST_CONNECTION_FAILURE =
    '[Entity Form] form test connection failure';
}
